module.exports = __webpack_public_path__ + "img/bg-header-default.98559ff7.webp";